module.exports = __webpack_public_path__ + "static/media/user.6d0f501b.svg";